export default __webpack_public_path__ + "static/media/opc.71cbac9c.jpg";